/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateWithEmailAddressContactResponseData,
  CreateWithEmailAddressContactResponseDataFromJSON,
  CreateWithEmailAddressContactResponseDataFromJSONTyped,
  CreateWithEmailAddressContactResponseDataToJSON
} from './CreateWithEmailAddressContactResponseData'

/**
 *
 * @export
 * @interface CreateWithEmailAddressContactResponse
 */
export interface CreateWithEmailAddressContactResponse {
  /**
   *
   * @type {number}
   * @memberof CreateWithEmailAddressContactResponse
   */
  status?: number
  /**
   *
   * @type {CreateWithEmailAddressContactResponseData}
   * @memberof CreateWithEmailAddressContactResponse
   */
  data?: CreateWithEmailAddressContactResponseData
}

export function CreateWithEmailAddressContactResponseFromJSON(json: any): CreateWithEmailAddressContactResponse {
  return CreateWithEmailAddressContactResponseFromJSONTyped(json, false)
}

export function CreateWithEmailAddressContactResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateWithEmailAddressContactResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateWithEmailAddressContactResponseDataFromJSON(json['data'])
  }
}

export function CreateWithEmailAddressContactResponseToJSON(value?: CreateWithEmailAddressContactResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateWithEmailAddressContactResponseDataToJSON(value.data)
  }
}
